import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AuthenticationService } from './features/authentication/services/authentication.service';
import { LoginResponse } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly authenticationService = inject(AuthenticationService);

  constructor() {
    // Check authentication first, then initialize listeners
    this.authenticationService
      .checkAuth()
      .subscribe((loginResponse: LoginResponse) => {
        const { isAuthenticated, accessToken } = loginResponse;

        if (isAuthenticated) {
          this.authenticationService.fortifyToken.next(accessToken);
        }

        // Initialize event listeners AFTER checkAuth completes
        this.authenticationService.refreshTokenEventListener();
        this.authenticationService.IsAuthenticatedAlert();
        this.authenticationService.getUserDataFromFortify();
      });
  }
}
